export enum Company {
  Zito = 'Žito'
}

export const CompanyOptions = [{ value: Company.Zito, label: Company.Zito }];
